var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5C4.275 5 4.51042 4.90208 4.70625 4.70625C4.90208 4.51042 5 4.275 5 4C5 3.725 4.90208 3.48958 4.70625 3.29375C4.51042 3.09792 4.275 3 4 3C3.725 3 3.48958 3.09792 3.29375 3.29375C3.09792 3.48958 3 3.725 3 4C3 4.275 3.09792 4.51042 3.29375 4.70625C3.48958 4.90208 3.725 5 4 5ZM4 10C2.65833 8.85833 1.65625 7.79792 0.99375 6.81875C0.33125 5.83958 0 4.93333 0 4.1C0 2.85 0.402083 1.85417 1.20625 1.1125C2.01042 0.370833 2.94167 0 4 0C5.05833 0 5.98958 0.370833 6.79375 1.1125C7.59792 1.85417 8 2.85 8 4.1C8 4.93333 7.66875 5.83958 7.00625 6.81875C6.34375 7.79792 5.34167 8.85833 4 10Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.6084b6460a414e5273c06f23d19f5fab.svg";
export { ForwardRef as ReactComponent };